export const NAMESPACES = [
  'common',
  'app',
  'tracker',
  'builder',
  'library',
  'session',
  'settings',
  'about',
  'wizard',
  'aiImport',
  'seo',
  'learn/common',
  'learn/faq',
  'learn/install',
  'learn/features',
  'learn/gettingStarted',
  'learn/sync',
  'learn/privacy',
  'learn/authoring',
  'learn/authoringDsl',
  'learn/authoringJs',
  'learn/authoringBuilder',
  'learn/authoringAiImport',
] as const;

export type Namespace = (typeof NAMESPACES)[number];

export const DEFAULT_NAMESPACE: Namespace = 'common';
